(function (window, $, app) {
    function Exception(name, msg) {
        this.name = name;
        this.message = msg;
    }

    app.Exception = Exception;
})(window, jQuery, app);
